// Ekran szybkiego wyboru (/start) po otwarciu aplikacji z ekranu telefonu.
// Ustawienie jest per urządzenie (localStorage), a „już pokazany" — per
// uruchomienie (sessionStorage), żeby przeładowanie po aktualizacji nie wracało
// na ekran wyboru. Oba zapisy mogą rzucić (tryb prywatny), więc w try/catch.
const ENABLED_KEY = 'rountine_launcher_enabled';
const SHOWN_KEY = 'rountine_launcher_shown';

export const launcherEnabled = () => {
    try {
        return localStorage.getItem(ENABLED_KEY) !== '0';
    } catch {
        return true;
    }
};

export const setLauncherEnabled = (on) => {
    try {
        localStorage.setItem(ENABLED_KEY, on ? '1' : '0');
    } catch {
        // Bez zapisu — ustawienie obowiązuje tylko do zamknięcia aplikacji.
    }
};

// Zwraca true tylko za pierwszym razem w danym uruchomieniu.
export const claimLauncherShow = () => {
    try {
        if (sessionStorage.getItem(SHOWN_KEY)) return false;
        sessionStorage.setItem(SHOWN_KEY, '1');
        return true;
    } catch {
        return true;
    }
};

// Aplikacja uruchomiona z ekranu telefonu (zainstalowana), a nie jako karta przeglądarki.
export const isStandalone = () => window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true;
